import { mockSarAnomalyItems, mockSarItems, mockSarSummary } from '@/__mocks__';

const sarApi = {
  requestAnomalyList() {
    return new Promise((resolve) => {
      const response = {
        data: {
          anomalies: mockSarAnomalyItems(),
        },
      };
      setTimeout(() => {
        resolve(response);
      }, 100);
    });
  },
  requestList() {
    return new Promise((resolve) => {
      const items = 10;
      const response = {
        data: {
          activities: mockSarItems(items),
          paging: {
            next_cursor: 'MjAyMS0wOC0wMVQxNToyNTo0OS4zODg3MjNa',
            next_link:
              'https://localhost/items?cursor=MjAyMS0wOC0wMVQxNToyNTo0OS4zODg3MjNa',
            total_count: items,
          },
        },
      };
      setTimeout(() => {
        resolve(response);
      }, 100);
    });
  },
  requestSummary() {
    return new Promise((resolve) => {
      const response = { data: mockSarSummary() };
      setTimeout(() => {
        resolve(response);
      }, 100);
    });
  },
};

export default sarApi;
